import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dp-detail',
  templateUrl: './dp-detail.component.html',
  styleUrls: ['./dp-detail.component.scss']
})
export class DpDetailComponent implements OnInit {

  @Input() showDetail: boolean = false;

  @HostBinding
  ('class') gridClass = 'd-flex w-100';

  constructor() {
  }

  ngOnInit(): void {
  }

}
